import { CiCirclePlus } from "react-icons/ci";
import ContentLayout from "../components/layout/ContentLayout";
import { Link, useNavigate } from "react-router-dom";
import OutletCard from "../components/OutletCard";
import { Input } from "antd";
import MyModal from "../components/MyModal";
import { useRef } from "react";
import Button from "../components/Button";
import { useSelector } from "react-redux";
import { getAllRewards } from "../actions/acc_actions";
import { useQuery } from "@tanstack/react-query";
import Loading from "../utils/Loading";
import { useTranslation } from "react-i18next";

export default function Rewards() {
  const { t } = useTranslation();
  const modalRef = useRef();
  const businessUrn = useSelector((state) => state.account.businessUrn);

  const { isLoading, data } = useQuery({
    queryKey: ["rewards", businessUrn],
    queryFn: () => getAllRewards(businessUrn),
    enabled: !!businessUrn,
  });

  if (isLoading) return <Loading />;

  const rewards = data?.body || [];
  const isEmpty = rewards.length === 0;

  const handleEdit = () => modalRef.current.showModal();
  const handleDelete = () => {};
  const handleAddStampDevice = () => {};

  return (
    <ContentLayout
      header={
        isEmpty ? (
          <div className="screen-notification">
            <img src="/assets/images/bg/rewards.png" alt="" />
            <h2 className="active">{t("no_reward_yet")}</h2>
            <h5>{t("rewards_instructions")}</h5>
            <Link className="btn primary" to="add">
              {t("add_first_reward")}
            </Link>
          </div>
        ) : (
          <h1>
            {t("welcome_to")} <span>{t("rewards")}</span>
          </h1>
        )
      }
      bodyVariant="transparent"
    >
      {!isEmpty && (
        <>
          <div className="outlet-cards">
            <Link to="add" className="outlet-add btn">
              <CiCirclePlus size={48} />
              <div className="outlet-add-content">
                <p>{t("add_new")}</p>
                <h4 className="active">{t("reward")}</h4>
              </div>
            </Link>

            {rewards.map((reward) => (
              <OutletCard
                key={reward.urn}
                businessName={reward.name || t("reward_name_fallback")}
                locationHint={
                  reward.stamp_count
                    ? `${reward.stamp_count} ${t("stamps")}`
                    : t("no_stamps_info")
                }
                created={reward.created}
                onDelete={handleDelete}
                showAddStampDevice={false}
                showDelete={false}
              />
            ))}
          </div>

          <MyModal
            ref={modalRef}
            title={t("add_stamp_code")}
            message={t("add_stamp_code_instructions")}
            imageSrc="/assets/images/modal/stamp.png"
            additionalContent={
              <>
                <Input placeholder={t("enter_stamp_code")} />
                <Button>{t("add")}</Button>
                <div className="list">
                  <h6>{t("stamps_device_code")}</h6>
                  <div className="row">
                    <h5 className="stamp-code">#5646528</h5>
                    <Button variant="secondary">{t("delete")}</Button>
                  </div>
                </div>
              </>
            }
          />
        </>
      )}
    </ContentLayout>
  );
}
